import { render } from "./ClientUpdatePhoto.vue?vue&type=template&id=b535a1f4"
import script from "./ClientUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./ClientUpdatePhoto.vue?vue&type=script&lang=js"

import "../../../src/assets/css/avatar.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__